<template>
  <div class="main_wrap">
    <Navigator :routeList="navigate" />
    <div class="course_intro">
      <template v-if="!ifReviewAccount">
        <el-popover
          v-model="feedbackPopVisible"
          :visible-arrow="false"
          trigger="manual"
          placement="bottom-start"
          popper-class="feedback-popper"
          :offset="20"
          :width="250"
        >
          <template #reference>
            <Feedback
              :views="feedbackViews"
              :average="feedbackAverage"
              :count="feedbackCount"
              :count-show="feedbackCountShow"
              :rate="feedbackRate"
              :rate-status="feedbackRateStatus"
              @update:rate="updateFeedbackRate"
              :favorite="feedbackFavorite"
              @update:favorite="updateFeedbackFavorite"
              :like="feedbackLike"
              :like-num="feedbackLikeNum"
              @update:like="updateFeedbackLike"
              @suggest="showSuggestionDialog"
            />
          </template>
          <template #default>
            <div class="feedback-submit" @click.stop>
              <div class="label">
                <!--              五星评价：-->
                <span>
                  {{ feedbackRateLabel }}
                  <span class="label-tip" v-if="feedbackRate === 0"
                    >请点击评分
                  </span>
                </span>
              </div>
              <el-rate
                class="star"
                v-model="feedbackRate"
                :icon-classes="[
                  'icon-rate-star-full',
                  'icon-rate-star-full',
                  'icon-rate-star-full',
                ]"
                void-icon-class="icon-rate-star-empty"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                allow-half
              />
              <el-button
                class="btn"
                type="primary"
                size="mini"
                plain
                round
                @click="handleFeedbackSubmit"
              >
                提交
              </el-button>
            </div>
          </template>
        </el-popover>
      </template>
      <div class="course_info">
        <div class="course_cover_wrap">
          <video
            controls
            class="course_cover"
            v-if="courseDetail.introVideo"
            :poster="courseDetail.introVideoThumbnail"
          >
            <source :src="courseDetail.introVideo" />
            对不起，您的浏览器不支持播放该视频
          </video>
          <img class="course_cover" v-else :src="cover" />
        </div>
        <div class="course_info_detail">
          <div class="course_info_title_wrap">
            <div class="course_title">
              {{ courseDetail.name }}
            </div>
            <Tag
              class="tag"
              :text="rangeType"
              color="#00A2E9"
              background="#f4faff"
              no-radius="top-left"
            />
            <template v-if="!ifReviewAccount">
              <div class="views">
                <img class="icon" :src="iconViews" alt="icon" />
                <span>{{ getLargeCountDisplay(feedbackViews) }}</span>
              </div>
            </template>
          </div>
          <div class="course_info_column_wrap">
            <div class="course_info_column">
              分类：{{
                courseDetail.courseTypeName ||
                courseDetail.provinceCourseTypeName
              }}
            </div>
            <div class="course_info_column">年级：{{ grades }}</div>
            <div class="course_info_column">
              简介：{{ activeintro.summary }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course_detail">
      <div class="term_change_button_wrap" v-if="showTermChange">
        <div
          class="term_change_button"
          :style="{ 'padding-right': termList.length > 1 ? '5rem' : '0' }"
        >
          已选：{{ activeGradeTermName }}
          <el-select
            class="term-select"
            ref="termSelect"
            size="small"
            v-model="activeTerm"
            :popper-append-to-body="false"
            v-if="termList.length > 1"
            @change="termChange"
          >
            <el-option
              v-for="(item, index) in termList"
              :key="index"
              :label="item.showText || item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span v-if="termList.length > 1">切换</span>
        </div>
      </div>
      <div class="tab_bar">
        <el-tabs v-model="activeTab" class="tabs">
          <el-tab-pane label="课程介绍" name="intro" key="intro">
            <div class="course_intro_detail" v-html="activeintro.intro"></div>
          </el-tab-pane>
          <el-tab-pane label="课程资源" name="resourse">
            <div class="nav_bar">
              <div
                v-for="item in showGradeTabs"
                :key="item.index"
                class="nav_bar_button"
                :class="{ active: item.index == activeGradeIndex }"
                @click="gradeChange(item)"
              >
                <div class="grade_main_title">
                  {{ item.title
                  }}{{
                    ["其他", "全部"].includes(item.title.trim())
                      ? ""
                      : activeTermTip
                  }}
                </div>
                <div class="level_tips" v-if="item.desc">
                  （{{ item.desc }}）
                </div>
              </div>
            </div>
            <div class="course_list" v-if="showCourseList.length > 0">
              <div
                class="course_list_cell"
                v-for="course in showCourseList"
                :key="course.id"
              >
                <div
                  class="course_list_cell_title"
                  v-if="course.resourceFlag"
                  :class="{ hasResource: course.resourceFlag }"
                  @click="
                    loginStatus
                      ? getClassList(course.id)
                      : getResource(course.id)
                  "
                >
                  {{ course.title }}
                </div>
                <div class="course_list_cell_title" v-else>
                  {{ course.title }}
                </div>
                <div class="button_zone">
                  <div
                    class="course_list_cell_button"
                    v-if="courseDetail.offlineEnabled"
                    @click="getDownload(course.id)"
                  >
                    离线授课
                  </div>
                  <div
                    class="course_list_cell_button"
                    v-if="course.resourceFlag"
                    @click="
                      loginStatus
                        ? getClassList(course.id)
                        : getResource(course.id)
                    "
                  >
                    授课
                  </div>
                  <div class="no_resource_button" v-else-if="loginStatus">
                    内容更新中
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <Empty v-if="loginStatus" text="暂无资源" height="30rem" />
              <div v-else class="guest_empty">
                <div class="guest_empty_content">登录后查看更多资源</div>
                <el-button size="small" @click="login()">登录</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      class="class_dialog"
      :visible.sync="showClassDialog"
      width="74rem"
      show-close
      @close="classDialogClose()"
    >
      <div class="class_dialog_title_wrap">
        <img src="~@/assets/icons/icon_class.png" class="class_dialog_icon" />
        <div class="class_dialog_title">请选择本次授课的班级</div>
        <div class="class_dialog_subtitle">
          该课程今天有{{ classList.length }}个课后班需要您进行授课
        </div>
      </div>
      <div class="class_list">
        <div
          class="class_list_item"
          v-for="(item, index) in classList"
          :key="index"
          @click="chooseClass(item)"
        >
          <div class="class_list_left">
            <img
              v-if="item.teachingId === tempSelectedClass.teachingId"
              src="~@/assets/icons/checkbox_active.png"
              class="class_checkbox"
            />
            <img
              v-else
              src="~@/assets/icons/checkbox.png"
              class="class_checkbox"
            />
            <div class="class_info">
              <div class="class_name">
                {{ item.name }}
              </div>
              <div class="class_data">
                <div class="class_data_block">
                  <img
                    src="~@/assets/icons/icon_detail_location.png"
                    class="class_data_icon"
                  />
                  {{ item.schoolName }}
                </div>
                <div class="class_data_block">
                  <img
                    src="~@/assets/icons/icon_detail_student.png"
                    class="class_data_icon"
                  />
                  {{ item.enrollStudentCount }}人
                </div>
              </div>
            </div>
          </div>
          <div class="class_list_right">
            {{ item.startTime }}-{{ item.endTime }}
          </div>
        </div>
      </div>
      <div class="class_bottom">
        <div class="class_button cancel" @click="showClassDialog = false">
          取消
        </div>
        <div
          class="class_button normal"
          :style="{ opacity: tempSelectedClass.id ? 1 : 0.4 }"
          @click="confirmClass()"
        >
          去授课
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="resourse_dialog"
      :visible.sync="showDialog"
      width="55vw"
      show-close
    >
      <div class="resourse_title">授课资源</div>
      <div v-if="resourseList.length > 0">
        <el-tabs v-model="activeResourseTab">
          <el-tab-pane
            v-for="courseType in resourseList"
            :key="courseType.code"
            :label="courseType.name"
            :name="courseType.code"
          >
            <div class="resourse_body" v-if="courseType.data.length > 0">
              <div class="resourse_list_wrap">
                <div
                  class="resourse_list_item"
                  v-for="item in courseType.data"
                  :key="item.id"
                  :class="{ active: item.id == previewSourseInfo }"
                  @click="selectResourse(item)"
                >
                  {{ item.attachmentFileName }}
                </div>
              </div>
              <div
                class="resourse_preview_wrap empty"
                v-if="!previewSourseInfo"
              />
              <div
                class="resourse_preview_wrap"
                v-else-if="
                  previewResourseData.type === 'audio' &&
                  previewResourseData.mediaId
                "
              >
                <div class="audio_cover">
                  <div class="audio_info">
                    <div class="file_name">
                      {{ previewResourseData.fileName }}
                    </div>
                    <div class="file_duration">
                      {{ previewResourseData.duration }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="resourse_preview_wrap"
                v-else-if="
                  previewResourseData.covers &&
                  previewResourseData.covers.length > 0
                "
              >
                <div
                  class="resourse_preview_img_wrap"
                  v-for="item in previewResourseData.covers"
                  :key="item.index"
                >
                  <img :src="item.imgUrl" class="preview_resourse_img" />
                </div>
              </div>
              <div
                class="resourse_preview_wrap word"
                v-else-if="
                  previewResourseData.type === 'word' &&
                  previewResourseData.mediaUrl
                "
              >
                <iframe
                  class="word-preview"
                  :src="previewResourseData.mediaUrl"
                  :key="previewResourseData.mediaUrl"
                  frameborder="0"
                ></iframe>
              </div>
              <div
                class="resourse_preview_wrap pdf"
                v-else-if="
                  previewResourseData.type === 'pdf' &&
                  previewResourseData.mediaUrl
                "
              >
                <cafe-pdf
                  ref="pdf"
                  @on-success="pdfLoad"
                  @on-scroll="pdfScroll"
                  :filePath="pdfSrc"
                >
                  <template slot="footer">
                    <button :disabled="pdfCurrentNum <= 1" @click="pdfPre">
                      &lt;
                    </button>
                    <input
                      disabled
                      type="text"
                      :min="1"
                      :max="pdfPageNum"
                      v-model.number="pdfCurrentNum"
                      @change="pdfPageChange(pdfCurrentNum)"
                    />
                    <button
                      :disabled="pdfCurrentNum >= pdfPageNum"
                      @click="pdfNext"
                    >
                      &gt;
                    </button>
                  </template>
                </cafe-pdf>
              </div>
              <div class="resourse_preview_wrap empty" v-else>
                <Empty text="暂无预览" height="50vh" />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="resourse_body_empty" v-else>
        <Empty text="暂无资源" height="50vh" />
      </div>
      <div class="bottom">
        <div
          class="download_button"
          v-if="ifCanDownload"
          @click="downloadResource()"
        >
          <img src="@/assets/icons/icon_download.png" class="icon_download" />
          下载文件
        </div>
        <el-button type="primary" round @click="toPreview()">确定</el-button>
      </div>
    </el-dialog>
    <SuggestionDialog ref="SuggestionDialog"></SuggestionDialog>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import base64url from "base64url";
import Tag from "@/components/tag";
import Empty from "@/components/empty.vue";
import Navigator from "@/components/navigate.vue";
import Feedback from "@/components/feedback.vue";
import SuggestionDialog from "@/components/suggestionDialog.vue";
import defaultCover from "@/assets/images/default_cover.png";
import { getGrade, getDuration } from "@/utils/common";
import { tripleDesEncode } from "@/utils/security";
import {
  getPageDetail,
  getPageDetailGuest,
  getLessonResource,
  getDownloadUrl,
  downloadSource,
  updateCourseViewCount,
  updateTouristsCourseViewCount,
  getListTeachingClass,
  getCourseFeedbackData,
  getTouristsCourseFeedbackData,
  setCourseFeedbackRate,
  setCourseFeedbackFavorite,
  setCourseFeedbackLike,
} from "@/api/course";
import ICON_VIEWS from "@/assets/icons/feedback/views.png";
import { h } from "@vue/composition-api";

@Component({
  components: {
    Tag,
    Empty,
    Navigator,
    Feedback,
    SuggestionDialog,
  },
})
export default class CourseDetailPage extends Vue {
  navigate = []; // 导航面包屑数组
  courseId = ""; // 当前课程ID
  courseDetail = {}; // 课程信息详情
  activeTab = "intro"; // 选项卡，默认课程介绍
  activeResourseTab = ""; // 授课资源弹窗中的课程分类
  activeGradeIndex = 0; // 授课资源年级
  activeGradeName = ""; // 当前年级名称
  activeTermName = ""; // 当前学期名称
  activeTerm = "";

  gradeType = "grade";
  termGradeCombine = {}; // 学期年级对应关系
  termList = []; // 学期列表
  gradeTabs = []; // 年级标签列表

  showClassDialog = false; // 选择学校弹窗
  classList = []; // 班级列表
  tempSelectedClass = {}; // 弹窗中选择的学校
  selectedClass = ""; // 用户确认选择的班级
  selectedSchool = ""; // 用户确认选择的学校

  courseResourseList = []; // 根据年级分组的课资源数据列表
  showDialog = false; // 资源预览弹窗
  resourseList = []; // 弹窗展示的资源详情列表
  previewSourseInfo = null; // 当前正在预览的资源信息
  previewSourceId = ""; // 当前预览课件ID

  defaultCover = defaultCover;

  // 每次弹窗初始化数据
  @Watch("showDialog")
  dialogShowWatch(newVal, oldVal) {
    if (!newVal && newVal !== oldVal) {
      this.previewSourceId = "";
      this.previewSourseInfo = null;
    }
  }

  // 切换标签时重置预览
  @Watch("activeResourseTab")
  tabChangeWatch(nv, ov) {
    if (nv && nv !== ov) {
      let newList;
      this.resourseList.forEach((item) => {
        if (item.code === nv) {
          newList = item.data;
        }
      });
      const defaultSourse = newList.length ? newList[0] : {};
      this.previewSourseInfo = defaultSourse.id;
    }
  }

  // 登录状态，非登录游客模式只能看到第一条的资源且无法下载
  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  // 审核账号（黑名单账号）无法下载
  get ifReviewAccount() {
    return this.$store.state.UserModule.userInfo?.hasReviewAccount;
  }

  get activeGradeTermName() {
    const { activeGradeName, activeTermName } = this;
    if (activeGradeName) {
      if (activeGradeName.trim() !== activeTermName.trim()) {
        //code未固定
        if (activeGradeName === "其他") {
          return activeGradeName;
        } else {
          return activeGradeName + activeTermName;
        }
      }
      return activeGradeName;
    } else return "";
  }

  get showTermChange() {
    // 为审核账号，则永久隐藏
    if (this.ifReviewAccount) {
      return false;
    } else {
      if (this.gradeType === "level") return false;
      else if (this.gradeTabs.length == 0 && this.termList.length == 0)
        return false;
      else if (this.activeGradeName == "全部" && this.activeTermName == "全部")
        return false;
      else return true;
    }
  }

  get cover() {
    if (this.courseDetail.introVideoThumbnail)
      return this.courseDetail.introVideoThumbnail;
    else if (
      this.courseDetail.coverImgUrls &&
      this.courseDetail.coverImgUrls.length > 0
    )
      return this.courseDetail.coverImgUrls[0];
    else return defaultCover;
  }
  get rangeType() {
    if (this.courseDetail.courseTypeName) {
      return this.courseDetail.provinceCourseTypeName;
    } else {
      return "省级课程";
    }
  }
  get grades() {
    if (this.courseDetail.courseGradeTermList) {
      const gradeArr = this.courseDetail.courseGradeTermList.map((item) => {
        return item.grade;
      });
      return getGrade(gradeArr);
    } else return "-";
  }

  get showGradeTabs() {
    if (this.gradeType === "grade")
      return this.gradeTabs.filter(
        (item) => item.termId == this.activeTerm || !(item.term || "").trim()
      );
    else return this.gradeTabs;
  }

  get showCourseList() {
    if (this.courseResourseList.length > 0) {
      const data = this.courseResourseList[this.activeGradeIndex];
      return data;
    } else return [];
  }
  // 获取预览课件信息
  get previewResourseData() {
    let res = [];
    if (this.resourseList.length > 0) {
      let selectResourse;
      this.resourseList.forEach((courseType) => {
        courseType.data.forEach((item) => {
          if (item.id == this.previewSourseInfo) {
            selectResourse = item;
          }
        });
      });
      console.log(selectResourse, "选中资源");
      if (selectResourse.attachmentType == "ppt") {
        let covers = [];
        if (typeof selectResourse.thumbnails == "string")
          selectResourse.thumbnails = JSON.parse(selectResourse.thumbnails);
        if (selectResourse.thumbnails.length > 0) {
          covers = selectResourse.thumbnails.map((item, index) => {
            return {
              imgUrl: item,
              index: index,
            };
          });
        }
        res = {
          type: "ppt",
          covers,
        };
      } else if (selectResourse.attachmentType == "word") {
        res = {
          type: "word",
          mediaUrl: selectResourse.attachmentPlayUrl,
          mediaId: selectResourse.attachmentMediaId,
        };
      } else if (selectResourse.attachmentType == "pdf") {
        res = {
          type: "pdf",
          mediaUrl: selectResourse.attachmentPlayUrl,
          mediaId: selectResourse.attachmentMediaId,
        };
        this.pdfSrc = selectResourse.attachmentPlayUrl;
      } else if (
        selectResourse.attachmentType == "video" ||
        selectResourse.attachmentType == "audio"
      ) {
        let covers = null;
        if (
          selectResourse.thumbnails &&
          typeof selectResourse.thumbnails == "string"
        ) {
          covers = JSON.parse(selectResourse.thumbnails);
        } else covers = [];
        res = {
          type: selectResourse.attachmentType,
          covers: covers.map((item, index) => {
            return {
              imgUrl: item,
              index: index,
            };
          }),
          mediaId: selectResourse.attachmentMediaId,
          fileName: selectResourse.attachmentFileName,
        };
        if (selectResourse.duration) {
          res.duration = getDuration(selectResourse.duration);
        }
      }
    }
    return res;
  }

  // 获取完整信息
  get previewResourseDataFull() {
    let selectResourse;
    this.resourseList.forEach((courseType) => {
      courseType.data.forEach((item) => {
        if (item.id == this.previewSourseInfo) {
          selectResourse = item;
        }
      });
    });
    return selectResourse;
  }

  get ifCanDownload() {
    let type = false;
    if (this.previewResourseDataFull) {
      type =
        ["word", "pdf"].indexOf(this.previewResourseDataFull.attachmentType) >
        -1;
    }
    return (
      this.activeResourseTab == "Design" &&
      this.previewSourseInfo &&
      type &&
      this.loginStatus
    );
  }

  //课程介绍 根据当前学期展示相应学期介绍 没有取默认介绍
  get activeintro() {
    const {
      activeTerm,
      courseDetail: {
        courseTermIntroList = [],
        summary = "",
        intro = "",
        currentTermId,
      },
    } = this;

    //专家账号返回默认
    if (this.ifReviewAccount) {
      return {
        intro,
        summary,
      };
    }

    let _activeTermValue =
      typeof activeTerm === "number" ? activeTerm : currentTermId;
    let _curShowTermData = courseTermIntroList.find(
      (i) => i.term === _activeTermValue
    );
    return {
      intro: _curShowTermData?.intro ?? intro,
      summary: _curShowTermData?.brief ?? summary,
    };
  }

  //根据当前选择学期在当前课程资源的年级菜单上加上tip
  get activeTermTip() {
    const { activeTerm } = this;
    if (typeof activeTerm === "number") {
      let _map = {
        0: `(上)`,
        1: `(下)`,
      };
      return _map[activeTerm] || "";
    } else {
      return "";
    }
  }

  mounted() {
    this.courseId = this.$route.params.id;
    const { target } = this.$route.query;
    if (target == "resourse") {
      this.activeTab = "resourse";
    }
    this.getDetail();
    this.getFeedbackData();
    this.bindFeedbackEvent();
    this.updateViewCount();
  }
  destroyed() {
    this.unbindFeedbackEvent();
  }
  back() {
    this.$router.go(-1);
  }
  login() {
    this.$router.push("/login");
  }
  getDetail() {
    const that = this;
    if (this.$store.state.AuthModule.initStatus) {
      const fetch = this.loginStatus ? getPageDetail : getPageDetailGuest;
      fetch(this.courseId).then((data) => {
        this.courseDetail = data;
        if (data.gradeTermLessonResourceVoList.length > 0) {
          this.gradeType = "grade";
          const { gradeList, termList } = this.getGradeAndTerm(data);
          this.gradeTabs = gradeList;
          this.termList = termList;
          if (this.termList.length > 0) {
            const { currentTermName, currentTermId } = data;
            //展示规则：当前返回学期 - 全学期 - 列表第一个
            let hasCurTerm = this.termList.find(
              ({ value }) => value === currentTermId
            );
            let fullTerm = this.termList.find(({ value }) => value === 2);
            this.activeTermName = hasCurTerm
              ? currentTermName
              : fullTerm
              ? fullTerm.text
              : this.termList[0].text;
            this.activeTerm = hasCurTerm
              ? currentTermId
              : fullTerm
              ? fullTerm.value
              : this.termList[0].value;
            //根据筛选结果返回正确年级
            this.$nextTick(() => {
              const { title, index } = this.showGradeTabs[0];
              this.activeGradeIndex = index;
              this.activeGradeName = title;
            });
          }
          const initGradeInfo = gradeList[0];
          this.gradeChange(initGradeInfo);
        } else {
          data.levelLessonResourceVoList.forEach((item, index) => {
            this.gradeTabs.push({
              index: index,
              title: item.name,
              desc: item.applyGradeDesc,
              levelId: item.id,
            });
            this.$set(this.courseResourseList, index, item.courseLessonList);
          });
          this.gradeType = "level";
        }
        this.getNavigator();
      });
    } else {
      setTimeout(() => {
        that.getDetail();
      });
    }
  }

  getNavigator() {
    const { from, keywords } = this.$route.query;
    const { topicId, title, count } = this.$route.query;
    const courseDetail = this.courseDetail;
    // 1来自首页
    if (from == "1") {
      this.navigate = [
        { name: "首页", url: "/course" },
        { name: "课程详情", isCurrent: true },
      ];
    }
    // 2来自工作台
    else if (from == "2") {
      this.navigate = [
        { name: "首页", url: "/course" },
        { name: "教师工作台", url: "/workspace" },
        { name: "课程详情", isCurrent: true },
      ];
    }
    // 3来自专题
    else if (from == "3") {
      this.navigate = [
        { name: "首页", url: "/course" },
        {
          name: title,
          url: `/course/topicContent/${topicId}?from=1&title=${title}&count=${count}`,
        },
        { name: "课程详情", isCurrent: true },
      ];
    } else if (from == "search") {
      this.navigate = [
        { name: "首页", url: "/course" },
        { name: "资源搜索", url: `/course/resource?keywords=${keywords}` },
        { name: "课程详情", isCurrent: true },
      ];
    } else if (from == "collection") {
      this.navigate = [
        { name: "我的收藏", url: `/mine/myCollection` },
        { name: "课程详情", isCurrent: true },
      ];
    } else {
      let type = "";
      if (!this.ifReviewAccount) {
        //如果是省精品下的六大类，则会有courseTypeName的返回，如果是思政教育、作业辅导、劳动教育，则没有。
        type = courseDetail.courseTypeName
          ? `${courseDetail.provinceCourseType},${courseDetail.courseType}`
          : `${courseDetail.provinceCourseType}`;
      }
      this.navigate = [
        { name: "首页", url: "/course" },
        {
          name: "全部课程",
          routeName: "courseList",
          params: {
            type,
            isNew: true,
          },
        },
        { name: "课程详情", isCurrent: true },
      ];
    }
  }

  getGradeAndTerm(data) {
    const gradeList = [];
    const termList = [];
    if (data.gradeTermLessonResourceVoList)
      data.gradeTermLessonResourceVoList.forEach((item, index) => {
        gradeList.push({
          index: index,
          grade: item.grade,
          name: item.gradeTermId,
          title: item.gradeName,
          termId: item.term,
          term: item.termName,
        });
        const termItem = {
          text: item.termName,
          value: item.term,
        };
        const termListVal = termList.map((item) => item.value);
        if (termListVal.indexOf(termItem.value) < 0 && termItem.text.trim()) {
          termList.push(termItem);
        }
        this.courseResourseList.push(item.courseLessonList);
        // 创建每个学期下的选中年级信息
        if (!this.termGradeCombine[item.term]) {
          this.termGradeCombine[item.term] = {
            activeGrade: null,
            activeGradeName: "",
          };
        }
      });
    return {
      gradeList,
      termList,
    };
  }
  gradeChange(item) {
    this.activeGradeIndex = item.index;
    this.activeGradeName = item.title;
    // 每次选择年级，更新对应的学期下面的选中年级的信息
    this.$set(this.termGradeCombine, item.termId, {
      activeGrade: item.index,
      activeGradeName: item.title,
    });
  }
  termChange(ev) {
    let disc = {};
    // 通过字典检索学期名
    this.termList.forEach((item) => {
      disc[item.value] = item.text;
    });
    this.activeTermName = disc[ev];
    // 读取之前选中的年级信息，如果无则默认选中第一个
    if (this.termGradeCombine[ev].activeGrade) {
      const gradeIndex = this.termGradeCombine[ev].activeGrade;
      this.gradeChange(this.gradeTabs[gradeIndex]);
    } else {
      this.gradeChange(this.showGradeTabs[0]);
    }
  }
  getDownload(id) {
    let params;
    if (this.gradeType === "grade")
      params = {
        type: 1,
        lessonId: id,
        courseName: this.courseDetail.name,
        gradeTerm: this.gradeTabs[this.activeGradeIndex].title,
      };
    else if (this.gradeType === "level")
      params = {
        type: 1,
        courseName: this.courseDetail.name,
        horizontalLevelName: this.gradeTabs[this.activeGradeIndex].title,
        lessonId: id,
      };
    getDownloadUrl(params).then((data) => {
      window.open(data, "_blank");
    });
  }
  getClassList(id) {
    this.tempSelectedClass = {};
    this.selectedClass = "";
    this.selectedSchool = "";
    this.tempResourseId = id;
    getListTeachingClass(this.courseId).then((data) => {
      if (data?.length > 1) {
        this.classList = data;
        this.showClassDialog = true;
      } else {
        if (data.length == 1) {
          this.tempSelectedClass = data[0];
          this.selectedClass = this.tempSelectedClass.id;
          this.selectedSchool = this.tempSelectedClass.schoolId;
        }
        this.getResource(id);
      }
    });
  }
  chooseClass(classInfo) {
    this.tempSelectedClass = classInfo;
  }
  confirmClass() {
    if (this.tempSelectedClass.id) {
      this.selectedClass = this.tempSelectedClass.id;
      this.selectedSchool = this.tempSelectedClass.schoolId;
      this.showClassDialog = false;
      setTimeout(() => {
        this.getResource(this.tempResourseId);
      }, 100);
    }
  }
  classDialogClose() {
    this.showClassDialog = false;
    this.tempSelectedClass = {};
  }
  getResource(id) {
    getLessonResource({
      lessonId: tripleDesEncode(id),
    }).then((data) => {
      this.resourseList = data;
      this.showDialog = true;
      this.previewSourceId = id;
      const selectGroup = this.resourseList && this.resourseList[0];
      const selectItem = selectGroup.data.length ? selectGroup.data[0] : {};
      if (selectItem) {
        this.activeResourseTab = data[0].code;
        this.$nextTick(() => {
          this.selectResourse(selectItem);
        });
      }
    });
  }
  selectResourse(item) {
    this.previewSourseInfo = item.id;
  }
  downloadResource() {
    let params;
    if (this.gradeType === "grade")
      params = {
        courseName: this.courseDetail.name,
        gradeTerm: this.gradeTabs[this.activeGradeIndex].title,
        id: this.previewResourseDataFull.id,
      };
    else if (this.gradeType === "level")
      params = {
        courseName: this.courseDetail.name,
        horizontalLevelName: this.gradeTabs[this.activeGradeIndex].title,
        id: this.previewResourseDataFull.id,
      };
    downloadSource(params).then((data) => {
      const a = document.createElement("a");
      a.href = data;
      a.download = this.previewResourseDataFull.attachmentFileName;
      a.click();
    });
  }
  toPreview() {
    if (this.previewSourceId && this.previewSourseInfo) {
      if (this.previewResourseData.type == "ppt") {
        const data = {
          name: "viewerIndex",
          params: {
            id: this.previewSourceId,
            uid: this.previewSourseInfo,
          },
          query: {
            grade: this.gradeTabs[this.activeGradeIndex].grade,
            teachingAuxiliaryId: this.teachingAuxiliaryId,
            classId: this.selectedClass,
            schoolId: this.selectedSchool,
          },
        };
        if (localStorage.getItem("googleCheck") == "true") {
          window.open(this.$router.resolve(data).href, "_blank");
        } else {
          this.$confirm(
            "由于浏览器的兼容性限制，为保证课件最佳播放效果，建议使用“谷歌浏览器”查看课件",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "好的",
              cancelButtonText: "不再提醒",
              center: true,
            }
          )
            .then(() => {
              window.open(this.$router.resolve(data).href, "_blank");
            })
            .catch((action) => {
              if (action == "cancel") {
                localStorage.setItem("googleCheck", true);
              }
            });
        }
      } else if (this.previewResourseData.type == "word") {
        const url = this.previewResourseData.mediaUrl;
        const data = {
          name: "resViewer",
          params: {
            uid: this.previewSourseInfo,
            url: base64url.encode(url),
          },
          query: {
            grade: this.gradeTabs[this.activeGradeIndex].grade,
            type: this.previewResourseData.type,
            teachingAuxiliaryId: this.teachingAuxiliaryId,
            classId: this.selectedClass,
            schoolId: this.selectedSchool,
          },
        };
        console.log(data);
        window.open(this.$router.resolve(data).href, "_blank");
      } else if (this.previewResourseData.type == "pdf") {
        const url = this.previewResourseData.mediaUrl + "#toolbar=0";
        const data = {
          name: "resViewer",
          params: {
            uid: this.previewSourseInfo,
            url: base64url.encode(url),
          },
          query: {
            grade: this.gradeTabs[this.activeGradeIndex].grade,
            type: this.previewResourseData.type,
            teachingAuxiliaryId: this.teachingAuxiliaryId,
            classId: this.selectedClass,
            schoolId: this.selectedSchool,
          },
        };
        window.open(this.$router.resolve(data).href, "_blank");
      } else if (
        this.previewResourseData.type == "video" ||
        this.previewResourseData.type == "audio"
      ) {
        const data = {
          name: "videoPlay",
          params: {
            mediaId: this.previewResourseData.mediaId,
            uid: this.previewSourseInfo,
          },
          query: {
            grade: this.gradeTabs[this.activeGradeIndex].grade,
            type: this.previewResourseData.type,
            teachingAuxiliaryId: this.teachingAuxiliaryId,
            classId: this.selectedClass,
            schoolId: this.selectedSchool,
          },
        };
        window.open(this.$router.resolve(data).href, "_blank");
      }
    } else {
      this.showDialog = false;
    }
  }

  pdfSrc = "";
  pdfPageNum = null;
  pdfScale = 1;
  pdfCurrentNum = 1;

  pdfPageChange() {
    this.file = this.src;
  }
  pdfLoad(val) {
    this.pageNum = val;
  }
  pdfSetScale() {
    this.$refs.pdf.changeScale(this.scale);
  }
  pdfScroll(val) {
    this.currentNum = val;
  }
  pdfPre() {
    this.$refs.pdf.prePage();
  }
  pdfNext() {
    this.$refs.pdf.nextPage();
  }
  pdfFileChanged(val) {
    this.$refs.pdf.goToPage(val);
  }
  pdfPrint() {
    this.$refs.pdf.printFile();
  }

  // New Function
  iconViews = ICON_VIEWS;
  feedbackPopVisible = false;
  feedbackViews = 0;
  feedbackAverage = 0;
  feedbackCount = 0;
  feedbackCountShow = false;
  feedbackRate = 0;
  feedbackRateStatus = false;
  get feedbackRateLabel() {
    const rate = this.feedbackRate;
    if (rate == 0) {
      return "";
    } else if (rate <= 1) {
      return "很差";
    } else if (rate <= 2) {
      return "较差";
    } else if (rate <= 3) {
      return "一般";
    } else if (rate <= 4) {
      return "推荐";
    } else {
      return "极力推荐";
    }
  }
  getLargeCountDisplay(count) {
    const limit = 1e4;
    if (count < limit) {
      return count;
    }
    return Math.floor((count / limit) * 100) / 100 + "w";
  }
  feedbackPopOuterClick() {
    this.feedbackPopVisible = false;
  }
  bindFeedbackEvent() {
    window.document.addEventListener("click", this.feedbackPopOuterClick);
  }
  unbindFeedbackEvent() {
    window.document.removeEventListener("click", this.feedbackPopOuterClick);
  }
  noLoginTip() {
    const msgOption = {
      type: "warning",
      customClass: "errorTips",
      // message: "请登录后再进行操作",
      message: h("p", { style: "color: #666666 ; font-size: 14px" }, [
        h("span", null, "请 "),
        h(
          "span",
          {
            style:
              "text-decoration: underline ; color : #00a2e9 ; cursor : pointer",
            on: {
              click: () => {
                this.login();
              },
            },
          },
          "登录"
        ),
        h("span", null, " 之后再进行操作"),
      ]),
    };
    this.$message(msgOption);
  }
  updateFeedbackRate(value) {
    if (!this.loginStatus) {
      this.noLoginTip();
    } else {
      this.feedbackPopVisible = !this.feedbackPopVisible;
    }
  }
  feedbackFavorite = false;
  updateFeedbackFavorite(value) {
    if (!this.loginStatus) {
      this.noLoginTip();
    } else {
      const favorite = this.feedbackFavorite;
      const newValue = !favorite;
      setCourseFeedbackFavorite(this.courseId, newValue)
        .then(() => {
          this.feedbackFavorite = !favorite;
          const msgOption = {
            type: "success",
            customClass: "errorTips",
            message: favorite ? "已取消收藏" : "收藏成功",
          };
          this.$message(msgOption);
        })
        .catch((err) => console.log(err));
    }
  }
  feedbackLike = false;
  feedbackLikeNum = 0;
  updateFeedbackLike(value) {
    if (!this.loginStatus) {
      this.noLoginTip();
    } else {
      const like = this.feedbackLike;
      const likeNum = this.feedbackLikeNum;
      const newValue = !like;
      setCourseFeedbackLike(this.courseId, newValue)
        .then(() => {
          if (like) {
            this.feedbackLikeNum = likeNum - 1;
            this.feedbackLike = false;
          } else {
            this.feedbackLikeNum = likeNum + 1;
            this.feedbackLike = true;
          }
          const msgOption = {
            type: "success",
            customClass: "errorTips",
            message: like ? "已取消点赞" : "点赞成功",
          };
          this.$message(msgOption);
        })
        .catch((err) => console.log(err));
    }
  }
  handleFeedbackSubmit() {
    if (this.feedbackRate <= 0) {
      return this.$message({
        type: "error",
        customClass: "errorTips",
        message: "请选择评分后再提交",
      });
    }
    setCourseFeedbackRate(this.courseId, this.feedbackRate)
      .then(() => {
        this.feedbackRateStatus = true;
        this.feedbackPopVisible = false;
      })
      .then(() => {
        const msgOption = {
          type: "success",
          customClass: "errorTips",
          message: "评价成功",
        };
        this.$message(msgOption);
      })
      .then(() => this.getFeedbackData())
      .catch((err) => console.log(err));
  }
  getFeedbackData() {
    const fn = this.loginStatus
      ? getCourseFeedbackData
      : getTouristsCourseFeedbackData;
    fn(this.courseId)
      .then((data) => {
        if (!data) return null;
        const {
          commentAvg,
          commentCount,
          likeCount,
          viewCount,
          userComment,
          userFavorite,
          userLike,
        } = data;
        this.feedbackViews = viewCount;
        this.feedbackAverage = commentAvg;
        this.feedbackCount = commentCount;
        this.feedbackCountShow = commentCount >= 100;
        this.feedbackRate = userComment || 0;
        this.feedbackRateStatus = userComment !== 0 && userComment !== null;
        this.feedbackFavorite = userFavorite;
        this.feedbackLike = userLike;
        this.feedbackLikeNum = likeCount;
      })
      .catch((err) => console.log(err));
  }
  updateViewCount() {
    const fn = this.loginStatus
      ? updateCourseViewCount
      : updateTouristsCourseViewCount;
    fn(this.courseId)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  }
  showSuggestionDialog() {
    if (!this.loginStatus) {
      this.noLoginTip();
    } else {
      this.$refs.SuggestionDialog.showSuggestionDialog();
    }
  }
}
</script>

<style lang="scss" src="../../../src/assets/styles/feedback.scss"></style>
<style lang="less" scoped>
/deep/ .el-tabs__nav-wrap::after {
  background: none;
}

.label-tip {
  color: #969696 !important;
  font-size: 14px;
  font-weight: 400;
}

.course_intro {
  background: #ffffff;
  padding: 2.5rem 2rem;
  border-radius: 0.4rem;
  margin-top: 1.5rem;

  .title_text {
    font-size: 2.2rem;
  }

  .course_info {
    margin-top: 1.5rem;
    display: flex;

    .course_cover_wrap {
      height: 15.5rem;
      width: 27.6rem;
      border-radius: 0.4rem;
      display: flex;
      align-items: center;
      overflow: hidden;

      .course_cover {
        width: 27.6rem;
        height: 15.5rem;
      }
    }

    .course_info_detail {
      margin-left: 2.5rem;
      display: flex;
      flex-direction: column;

      .course_info_title_wrap {
        display: flex;
        align-items: center;
      }

      .course_title {
        font-size: 2.2rem;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .tag {
        margin-left: 1.5rem;
      }

      .views {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        margin-left: 2rem;
        margin-top: 0.25rem;
        color: #999;
        * {
          vertical-align: top;
        }
        .icon {
          width: 2.2rem;
          height: 2.2rem;
        }
      }

      .course_info_column_wrap {
        margin-top: 2rem;

        .course_info_column {
          color: #666666;
          font-size: 1.4rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}

.course_detail {
  background: #ffffff;
  padding: 3rem;
  margin-top: 2.2rem;
  border-radius: 0.4rem;
  position: relative;

  .term_change_button_wrap {
    position: absolute;
    top: 3rem;
    right: 3rem;
    display: inline-block;
    z-index: 10;

    .term_change_button {
      font-size: 1.6rem;
      position: relative;
      word-break: keep-all;
      white-space: nowrap;
      margin-top: 1.8rem;

      .term-select {
        position: absolute;
        width: 5rem;
        margin-right: -5rem;

        /deep/ .el-input__inner {
          border: none;
        }
      }

      span {
        position: absolute;
        padding: 0 1rem;
        color: #00a2e9;
        background: #fff;
        pointer-events: none;
      }
    }
  }

  .tab_bar {
    color: #000000;
    font-size: 1.8rem;

    .tabs {
      width: 100%;
    }

    .tab_bar_title {
      line-height: 4rem;
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-tabs__item {
      color: #000000;
      font-size: 2.2rem;
      font-weight: bold;
    }
  }

  .tab_body {
    min-height: 10rem;
  }

  .course_intro_detail {
    white-space: pre-wrap;
    margin-top: 2.5rem;

    /deep/ img {
      max-width: 50%;
      margin: 1rem auto;
      display: block;
    }
  }

  .nav_bar {
    display: flex;
    width: 100vw;
    overflow-x: auto;

    .nav_bar_button {
      cursor: pointer;
      font-size: 1.8rem;
      font-weight: bold;
      padding: 0.2rem 1rem;
      margin-right: 2.5rem;

      &.active {
        color: #00a2e9;
      }

      .grade_main_title {
        text-align: center;
      }

      .level_tips {
        margin-top: 0.5em;
        text-align: center;
        font-size: 1rem;
        font-weight: normal;
      }
    }
  }

  .course_list {
    margin-top: 1.5rem;
  }

  .course_list_cell {
    padding: 1.5rem 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f4faff;

      .course_list_cell_title {
        color: #00a2e9;
      }
    }

    .course_list_cell_title {
      color: #666666;
      font-size: 1.8rem;

      &.hasResource {
        cursor: pointer;
      }
    }

    .button_zone {
      display: flex;
    }

    .course_list_cell_button {
      margin-left: 1.5rem;
      font-size: 1.6rem;
      display: inline-block;
      height: 2.8rem;
      line-height: 2.8rem;
      border-radius: 1.4rem;
      color: #999999;
      background: #fff;
      border: #d2d2d2 1px solid;
      padding: 0 1.5rem;
      cursor: pointer;

      &:hover {
        background: #f4faff;
        color: #00a2e9;
        border-color: #00a2e9;
      }
    }

    // 暂无资源 的按钮，紧急修改
    .no_resource_button {
      padding: 0 1.6rem;
      color: #999999;
      font-size: 1.6rem;
      line-height: 2.8rem;
    }
  }

  .guest_empty {
    height: 30rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .guest_empty_content {
      font-size: 1.4rem;
      color: #999999;
      margin-bottom: 2rem;
    }
  }
}
.resourse_dialog,
.class_dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__title {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 2.5rem 3.5rem;
  }

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
}

.class_dialog {
  .class_dialog_title_wrap {
    display: flex;
    align-items: flex-end;
    .class_dialog_icon {
      width: 1.9rem;
      height: 1.6rem;
      margin-bottom: 2px;
    }
    .class_dialog_title {
      font-size: 2rem;
      color: #000000;
      font-weight: bold;
      margin-left: 0.8rem;
      margin-right: 1.2rem;
    }
    .class_dialog_subtitle {
      font-size: 1.6rem;
      color: #999999;
    }
  }
  .class_list {
    margin-top: 3rem;
    border-bottom: solid 1px #eeeeee;
  }
  .class_list_item {
    display: flex;
    justify-content: space-between;
    padding: 1.9rem 1.4rem;
    border: solid 1px #ffffff;
    background: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      border-color: #00a2e9;
      background: #f3fbff;
    }
    .class_list_left {
      display: flex;
      align-items: center;
      .class_checkbox {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 1.5rem;
      }
      .class_info {
        .class_name {
          color: #000000;
          font-size: 2rem;
          margin-bottom: 1.5rem;
        }
        .class_data {
          display: flex;
          align-items: center;
          color: #999999;
          font-size: 1.6rem;
          .class_data_block {
            margin-right: 3.6rem;
            .class_data_icon {
              height: 1.6rem;
            }
          }
        }
      }
    }
  }
  .class_bottom {
    margin-top: 3.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    .class_button {
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2rem;
      font-size: 1.4rem;
      cursor: pointer;
      &.cancel {
        background: #e5e5e5;
        color: #676767;
        width: 10.5rem;
      }
      &.normal {
        background: #00a2e9;
        color: #ffffff;
        margin-left: 2.4rem;
        width: 20rem;
      }
    }
  }
}

.resourse_dialog {
  .resourse_title {
    color: #202020;
    font-size: 2.2rem;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }

  .resourse_body {
    margin-top: 3.5rem;
    display: flex;
    justify-content: space-between;

    .resourse_list_wrap {
      flex: 1;
      height: 50vh;
      overflow: hidden;
      overflow-y: auto;

      .resourse_list_item {
        box-sizing: border-box;
        width: auto;
        max-height: 10rem;
        overflow: hidden;
        margin-bottom: 2rem;
        margin-right: 1rem;
        background: #f6f6f6;
        color: #000000;
        font-size: 1.4rem;
        padding: 2rem;
        border-radius: 0.4rem;
        border: solid 1px #f6f6f6;
        cursor: pointer;
        text-overflow: ellipsis;

        &:hover {
          border-color: #00a2e9;
        }

        &.active {
          background: #f3fbff;
          color: #00a2e9;
          border-color: #00a2e9;
        }
      }
    }

    .resourse_preview_wrap {
      margin-left: 3rem;
      flex: 2;
      height: 50vh;
      overflow: hidden;
      overflow-y: auto;

      &.empty {
        overflow-y: hidden !important;
      }

      .preview_resourse_img {
        width: 100%;
        height: auto;
      }

      .audio_cover {
        width: 100%;
        height: 100%;
        background: url("~@/assets/images/background_audio_preview.png")
          no-repeat;
        background-size: cover;
        background-position: right;

        .audio_info {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 6rem;

          .file_name {
            font-size: 2.4rem;
            color: #000000;
            font-weight: bold;
          }

          .file_duration {
            margin-top: 5%;
            font-size: 1.4rem;
            color: #999999;
          }
        }
      }
    }
  }

  .resourse_body_empty {
    height: 50vh;
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 2.5rem;

    .download_button {
      cursor: pointer;
      font-size: 14px;
      margin-right: 3.5rem;
      display: flex;
      align-items: center;
      color: #00a2e9;

      .icon_download {
        height: 15px;
      }
    }
  }
}

.word-preview {
  width: 100%;
  height: 100%;
}

::v-deep .pdf-footer {
  text-align: center;

  button {
    cursor: pointer;
    border: none;
    background: none;
    color: #666;
  }

  input[type="text"] {
    margin: 0 1rem;
    text-align: center;
    width: 4rem;
    border: none;
    background: none;
  }
}

/deep/ .el-tabs__item {
  height: 4rem;
  line-height: 4rem;
  font-size: 1.4rem;
  padding: 0 2rem;
}

/deep/ .el-button {
  font-size: 1.4rem;
}

/deep/ .el-button.is-round {
    border-radius: 2rem;
    padding: 1.2rem 2.3rem;
}
</style>
